import React, { useEffect, useState } from "react";
import "../../assets/css/validate.css";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import AlignTag from "./AllignTag";
import swal from "sweetalert";
import Swal from 'sweetalert2'
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import { CloseIcon, DeleteIcon, EditIcon, PlusIcon } from "../../iconshere";
import {
  useSelector,
} from "react-redux";
import {
  useNavigate,
} from "react-router-dom";
import moment from "moment";
import NoDataFound1 from "../nodatafound/NoDataFound1";


const Workflow = ({ groupId, searchIcon = true, search = "" }) => {
  const [showCreateWorkFlowModal, setShowCreateWorkFlowModal] = useState(false);
  const [showEditWorkFlowModal, setShowEditWorkFlowModal] = useState(false);
  const [workflowName, setWorkflowName] = useState("");
  const [workflowUniqueName, setWorkflowUniqueName] = useState("");
  const [version, setVersion] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selectedWorkFlow, setSelectedWorkFlow] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectAllUsers, setSelectAllUsers] = useState(false);
  const [userList, setUserList] = useState([]);
  const [UserCheckType, setUserCheckType] = useState("");
  const [userLength, setUserLength] = useState(0);
  const [userMessage, setUserMessage] = useState("Loading...");
  const [WorkFlowList, setWorkflowList] = useState([]);
  const [WorkflowMessage, setWorkflowMessage] = useState("");
  const [gridView, setGridView] = useState(false);
  const [workflowSelected_id, setWorkflowSelectedId] = useState(null);
  const [viewMode, setViewMode] = useState("NULL");
  const [versionlist, setVersionList] = useState([]);
  const [selectedAllignTag, setSelectedAllignTag] = useState([]);
  const [checkType, setCheckType] = useState("");
  const [lastversion, setLastVersion] = useState("");
  const [lastpublished, setLastPublished] = useState("");
  const [selectedWorkFlowName, setSelectedWorkFlowName] = useState("");
  const [NewVersion, setNewVersion] = useState();
  const [workflowEditData, setWorkflowEditData] = useState({});

  const [versionSelected_id, setVersionSelectId] = useState("");

  console.log(versionSelected_id);
  console.log(NewVersion);

  const [errors, setErrors] = useState({
    version: "",
  });
  const [options, setOptions] = useState({
    lines: [],
    user: [],
  });

  useEffect(() => {
    setSearchValue(search);
  }, [search]);

  const [deleteWorkFlowId, setDeleteWorkflowId] = useState(null);
  const [deleteWorkflowConfirm, setDeleteWorkflowConfirm] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [TagData, setTagData] = useState([]);

  const navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  var { apiBaseUrl } = configData.config;
  const { token } = userData;

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const getUserList = async () => {
    var { data } = await axios.get(`${apiBaseUrl}/api/uno/users/${groupId}`, {
      headers,
    });
    setOptions((prevOptions) => ({
      ...prevOptions,
      lines: data.data.map((user) => ({
        value: user.uuid,
        label: user.name,
        email: user.email,
      })),
    }));
    setUserList(data.list);
    setUserLength(data?.list?.length);
    // setUserMessage(data.list.length === 0 ? "No Record Found." : "");
  };

  const onWorkflowSubmit = async (e) => {
    e.preventDefault();
    var data = {
      workflow_name: workflowName,
      workflow_unique_name: workflowUniqueName,
      version: version,
      tag_aligned: selectedTags,
      user_aligned: selectedOption,
      group_uuid: groupId,
    };

    await axios
      .post(`${apiBaseUrl}/api/workflow/create`, data, {
        headers: headers,
      })
      .then(function (response) {
        console.log(response);
        if (response.status === 201) {
          if (response.data.error === false) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500
            });
            swal();
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "WorkFlow Created Succesfully",
              showConfirmButton: false,
              timer: 1500
            });

            getWorkflowList();
            handleWorkFlowModal(false);
          }
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  const getWorkflowList = async () => {
    await axios
      .get(`${apiBaseUrl}/api/workflow/bysite/${groupId}`, {
        headers: headers,
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            setWorkflowList(response.data.list);
            console.log(response.data.list);
            setWorkflowMessage(response.data.list.length === 0 ? "No Record Found." : "");
          } else {
            // auth_response_flow(response.data, (return_response) => {
            //   if (return_response.error === false && return_response.retry === true) {
            //   }
            // });
          }
        }
      })
      .catch(function (err) { });
  };

  const getTags = async () => {
    try {
      const data = {
        group_uuid: groupId,
      };

      const response = await axios.post(`${apiBaseUrl}/api/tags/gettags`, data, {
        headers,
      });

      if (response.status === 200) {
        if (response.data.error === false) {
          setTagData(response.data.data);
          // ListAlign: response.data.data,
          // message: "No Record Found.",
        } else {
          // Uncomment the following lines if you want to handle auth response flow
          // auth_response_flow(response.data, (return_response) => {
          //   if (return_response.error === false && return_response.retry === true) {
          //     current.getParentList();
          //   }
          // });
        }
      }
    } catch (err) { }
  };

  const openWorkFlow = (w_id, versionlist, workflow_name) => {
    setViewMode("VERSIONLIST");
    setWorkflowSelectedId(w_id);
    setVersionList(versionlist);
    setSelectedWorkFlowName(workflow_name);
    console.log(workflow_name, w_id, versionlist);
  };
  const selectAllUser = () => {
    setSelectAllUsers(!selectAllUsers);
    setSelectedOption(!selectAllUsers ? options.lines : []);
  };

  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
  };

  const handleWorkFlowModal = (e) => {
    setShowCreateWorkFlowModal(e);
  };

  const editWorkflow = (list) => {
    console.log(list);
    setWorkflowEditData({ ...list });
    setShowEditWorkFlowModal(true);
    setWorkflowSelectedId(list._id);
    getWorkflowList();
  };

  const deleteWorkFlow = async (id) => {
    setDeleteWorkflowConfirm(true);
    setDeleteWorkflowId(id);
  };

  const closeModal = () => {
    setUserCheckType("");
    setSelectedAllignTag([]);
    setCheckType("unchecked");
    setViewMode("NULL");
  };

  const versionlistNavigate = (v_id) => {
    let w_id = workflowSelected_id;
    navigate(`/workflow/tasks/${w_id}/${v_id}`, { state: selectedWorkFlowName });
  };

  const openNewVersion = () => {
    var version = 0;
    var lastpublished = null;
    if (versionlist.length > 0) {
      version = versionlist[versionlist.length - 1].version;
      var lastpublishedtemp = versionlist.find((x) => x.is_completed === true);
      if (lastpublishedtemp) {
        lastpublished = lastpublishedtemp.version;
      }
    }
    setViewMode("CREATEVERSION");
    setLastVersion(version);
    setLastPublished(lastpublished);
    setNewVersion(Number(version) + 1);
  };

  useEffect(() => {
    getUserList();
    getWorkflowList();
    getTags();
  }, [groupId]);

  const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
    return valid;
  };

  const cancelHandleDeleteWorkflow = async (id) => {
    setDeleteWorkflowConfirm(false);
    setDeleteWorkflowId(null);
  };

  const handleDeleteWorkflow = () => {
    const workflow_id = deleteWorkFlowId;
    axios
      .delete(`${apiBaseUrl}/api/workflow/deleteWorkflow/${workflow_id}`, {
        headers: headers,
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            setDeleteWorkflowId(null);
            setDeleteWorkflowConfirm(false);
            window.location.reload();
          }
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  const submitRelease = (e) => {
    e.preventDefault();
    var data = {
      workflow_id: workflowSelected_id,
      copy_version_id: versionSelected_id,
      version_name: NewVersion,
    };
    if (data.copy_version_id === undefined) {
      swal("Please Select The Version.");
      return;
    }

    axios
      .post(`${apiBaseUrl}/api/workflow/newversion`, data, {
        headers: headers,
      })
      .then(function (response) {
        if (response.status === 200) {
          getWorkflowList();
          setVersion("");
          setVersionSelectId(null);
          setViewMode("VERSIONLIST");
          closeModal();

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "New Version Created",
            showConfirmButton: false,
            timer: 1500
          });

        }
      })
      .catch(function (error) { });
  };

  return (
    <>
      <div className="page-content  pt-3">
        <div className="container-fluid">
          <div className="row corpheader">
            <div className="col-md-6">
              <form className=" app-search app-search1 d-flex justify-content-start">
                <div className="position-relative">
                  {searchIcon ? (
                    <>
                      <span className="bx bx-search-alt"></span>
                      <input
                        type="text"
                        name="searchName"
                        className="form-control"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        placeholder="Search Workflow"
                        autocomplete="off"
                      />
                    </>
                  ) : null}
                </div>
              </form>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <div className="text-md-right">
                <button className="redbtn" onClick={() => handleWorkFlowModal(true)}>
                  <PlusIcon />
                  Create Workflow
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            {gridView === true ? (
              <>
                {WorkFlowList.length === 0 ? (
                  WorkflowMessage === "" ? (
                    <div className="lds-spinner">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    // <div className="message-no-record">{WorkflowMessage}</div>
                    <NoDataFound1 heading="No Workflow Record Found" />
                  )
                ) : null}

                {WorkFlowList.filter(
                  (e) =>
                    !searchValue.length ||
                    e.workflow_name.toLowerCase().includes(searchValue.toLowerCase())
                ).map((list, index) => {
                  return (
                    <div className="col-md-3">
                      <div className="card workfloxboxn overflow-hidden">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-sm-12">
                              <div style={{ display: "flex", paddingBottom: "10px" }}>
                                <div className="profiledetail">
                                  <h5 className="font-size-15 mb-0">{list.workflow_name}</h5>
                                  {list.live_status === true ? (
                                    <span className="corpactive">Active</span>
                                  ) : (
                                    <span className="corpinactive">Inactive</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="adminsummery" style={{ justifyContent: "flex-start" }}>
                            <div className="buttons">
                              <button
                                className="btn btn-sm btn-outline-success wedit"
                                onClick={() => editWorkflow(list._id)}>
                                <i className="fa fa-edit"></i>
                              </button>

                              <button
                                onClick={() =>
                                  openWorkFlow(list._id, list.version, list.workflow_name)
                                }
                                className="btn btn-sm btn-outline-warning">
                                <i className="fa fa-eye"></i>
                              </button>

                              <button
                                onClick={() => deleteWorkFlow(list._id)}
                                className="btn btn-sm btn-outline-danger">
                                <i className="bx bx-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                <div className="table-responsive workflowtb">
                  <table className="table align-middle table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th>Workflow Name</th>
                        <th className="text-center">Workflow ID</th>
                        <th className="text-center">Current Version</th>
                        <th className="text-center">Last Updated</th>
                        <th className="text-center"></th>
                        <th style={{ textAlign: "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {WorkFlowList.filter(
                        (e) =>
                          !searchValue.length ||
                          e.workflow_name.toLowerCase().includes(searchValue.toLowerCase())
                      ).map((list, index) => (
                        <tr key={list._id}>
                          <td>{list.workflow_name}</td>
                          <td className="text-center">{list.workflow_unique_name}</td>
                          <td className="text-center">
                            {list?.version?.length > 0 && <span>{list.version[0].version}</span>}
                          </td>
                          <td className="text-center">{moment(list.updatedAt).format("lll")}</td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center">
                              <button
                                onClick={() =>
                                  openWorkFlow(
                                    list._id,
                                    list.version,
                                    list.workflow_name,
                                    list.workflow_unique_name
                                  )
                                }
                                className="btn btn-sm redbgbtn">
                                View
                              </button>
                            </div>
                          </td>

                          <td className="align-middle text-center userdrop">
                            <Dropdown>
                              <Dropdown.Toggle id="dropdown-basic">
                                <div className="options">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-three-dots-vertical"
                                    viewBox="0 0 16 16">
                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                  </svg>
                                </div>
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="sidebartopbar modulelistoptions">
                                <div className="listoptionsmodule">
                                  {/* <p onClick={() => editWorkflow(list)}>
                                    <EditIcon />
                                    Edit
                                  </p> */}
                                  <p onClick={() => deleteWorkFlow(list._id)}>
                                    <DeleteIcon />
                                    Delete
                                  </p>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {WorkFlowList.length === 0 ? (
                  WorkflowMessage === "" ? (
                    <div className="lds-spinner">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    <div className="message-no-record">{WorkflowMessage}</div>
                  )
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Create Workflow */}
      <Modal centered show={showCreateWorkFlowModal} onHide={() => handleWorkFlowModal(false)}>
        <Modal.Header className="popupheader" style={{ display: "flex" }}>
          <h4>Create Workflow</h4>
          <div style={{ cursor: "pointer" }} onClick={() => handleWorkFlowModal(false)}>
            <CloseIcon />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Workflow Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="workflow_name"
                  value={workflowName}
                  onChange={(e) => setWorkflowName(e.target.value)}
                />
              </div>

              {selectedWorkFlow === "" ? (
                <>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Workflow ID</label>
                        <input
                          type="text"
                          className="form-control"
                          name="workflow_unique_name"
                          value={workflowUniqueName}
                          onChange={(e) => setWorkflowUniqueName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Workflow Version</label>
                        <input
                          type="text"
                          className="form-control"
                          name="version"
                          value={version}
                          onChange={(e) => setVersion(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              <div className="form-group">
                <AlignTag setSelectedTags={setSelectedTags} TagData={TagData} />
              </div>

              <div className="form-group FormDropDown">
                <div className="row">
                  <div className="col-md-6 Wf_user">
                    <label>User List: </label>
                    <span>{selectedOption?.length} User Selected</span>
                  </div>

                  {/* Checkbox Select All User */}
                  <div className="col-md-6">
                    <input
                      className="form-check-input allUser"
                      type="checkbox"
                      checked={selectAllUsers}
                      onChange={() => selectAllUser(options.lines)}
                    />{" "}
                    Select All Users
                  </div>

                  <div className="col-md-12">
                    <Select
                      value={selectedOption}
                      onChange={handleSelectChange}
                      options={options.lines}
                      isMulti
                      placeholder="Select Users"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 d-flex justify-content-end mt-3 mb-2">
                  {selectedWorkFlow === "" ? (
                    <button className="redbgbtn" onClick={onWorkflowSubmit}>
                      Save
                    </button>
                  ) : (
                    <button className="redbgbtn" onClick={""}>
                      Update
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Workflow */}
      <Modal centered show={showEditWorkFlowModal} onHide={() => setShowEditWorkFlowModal(false)}>
        <Modal.Header className="popupheader" style={{ display: "flex" }}>
          <div style={{ cursor: "pointer" }} onClick={() => setShowEditWorkFlowModal(false)}>
            <CloseIcon />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Workflow Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="workflow_name"
                  value={workflowName}
                  onChange={(e) => setWorkflowName(e.target.value)}
                />
              </div>

              {selectedWorkFlow === "" ? (
                <>
                  <div className="form-group">
                    <label>Workflow ID</label>
                    <input
                      type="text"
                      className="form-control"
                      name="workflow_unique_name"
                      value={workflowUniqueName}
                      onChange={(e) => setWorkflowUniqueName(e.target.value)}
                    />
                  </div>

                  <div className="form-group">
                    <label>Version</label>
                    <input
                      type="text"
                      className="form-control"
                      name="version"
                      value={version}
                      onChange={(e) => setVersion(e.target.value)}
                    />
                  </div>
                </>
              ) : null}

              <AlignTag setSelectedTags={setSelectedTags} TagData={TagData} />

              <div className="form-group FormDropDown">
                <div className="row">
                  <div className="col-md-6 Wf_user">
                    <label>User List: </label>
                    <span>{selectedOption?.length} User Select</span>
                  </div>

                  {/* Checkbox Select All User */}
                  <div className="col-md-6">
                    <input
                      className="form-check-input allUser"
                      type="checkbox"
                      checked={selectAllUsers}
                      onChange={() => selectAllUser(options.lines)}
                    />{" "}
                    Select All Users
                  </div>

                  <div className="col-md-12">
                    <Select
                      value={selectedOption}
                      onChange={handleSelectChange}
                      options={options.lines}
                      isMulti
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 d-flex justify-content-end mt-3 mb-2">
                  {selectedWorkFlow === "" ? (
                    <button className="redbgbtn" onClick={onWorkflowSubmit}>
                      Save
                    </button>
                  ) : (
                    <button className="redbgbtn" onClick={""}>
                      Update
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* View Button */}
      <Modal centered show={viewMode === "VERSIONLIST"} onHide={closeModal}>
        <Modal.Header className="popupheader">
          Version
          <div className="createnev">
            <button
              style={{ background: "#fff", color: "#CA373C" }}
              className="redbtn"
              onClick={() => openNewVersion()}>
              <PlusIcon />
              Create New Version
            </button>
            <div style={{ cursor: "pointer" }} onClick={closeModal}>
              <CloseIcon />
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="version">
            <table className="table align-middle  ">
              <thead>
                <tr>
                  <th style={{ width: "50%" }}>Version List</th>
                  <th className="text-center">View Version</th>
                  <th className="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                {versionlist.map((list, index) => {
                  console.log(versionlist);
                  return (
                    <tr>
                      <td>
                        {list.version} {list.status}
                      </td>
                      <td className="text-center d-flex justify-content-center ">
                        <button
                          onClick={() => versionlistNavigate(list._id)}
                          className="btn btn-sm redbgbtn">
                          View
                        </button>
                      </td>
                      <td className="text-center ">
                        <label
                          style={{
                            color: `${list.status === true ? "#ca373c" : "#333333"}`,
                            margin: "0",
                          }}>{`${list.status === true ? "Active" : "Inactive"}`}</label>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      {/* Create Version */}
      <Modal centered show={viewMode === "CREATEVERSION"} onHide={closeModal}>
        <Modal.Header className="popupheader">
          Create Version
          <div style={{ cursor: "pointer" }} onClick={closeModal}>
            <CloseIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="version createversion">
            <div className="form-group">
              <label style={{ marginBottom: "0" }}>
                Last Created Version : <span style={{ color: "#c51a1a" }}>{lastversion}</span>
              </label>
            </div>

            <div className="form-group">
              <label for="exampleInputEmail1">New Version</label>
              <input
                style={{ fontSize: "14px" }}
                type="number"
                step="1.0"
                onChange={(e) => setNewVersion(e.target.value)}
                name="version"
                className="form-control"
                placeholder="Enter Version"
                value={NewVersion}
                disabled
              />
              {errors.version.length > 0 && <span className="text-danger">{errors.version}</span>}
            </div>

            <div className="mt-2 ver-list">
              <div className="item">
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id={`customRadio01`}
                    value={version}
                    onChange={(e) => setVersionSelectId(null)}
                    name="mcqBankRadio"
                    className="custom-control-input"
                  />
                  <label className="custom-control-label" for={`customRadio01`}>
                    Create New Tasks
                  </label>
                </div>
              </div>
              <label>Import Previous Version Tasks </label>
              {versionlist?.map((list, index) => (
                <div className="item">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id={`customRadio${index + 10}`}
                      value={list?.id}
                      onChange={() => setVersionSelectId(list?._id)}
                      name="mcqBankRadio"
                      className="custom-control-input"
                    />
                    <label className="custom-control-label" for={`customRadio${index + 10}`}>
                      {" "}
                      {list.version}
                    </label>
                  </div>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-12 d-flex justify-content-end mt-3 mb-2">
                <button className="redbgbtn" onClick={submitRelease}>
                  Create
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete Workflow */}
      <Modal centered show={deleteWorkflowConfirm} onHide={cancelHandleDeleteWorkflow}>
        <Modal.Header className="popupheader delete pt-4">Delete Workflow</Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group pt-4 pb-5 m-0">
                <p className="popupheading delete p-0 m-0">
                  Do you really want to delete this Workflow?
                </p>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-center mt-2 mb-2">
                  <button className=" redbgbtn cancel" onClick={cancelHandleDeleteWorkflow}>
                    Cancel
                  </button>
                  <button className="ms-3 redbgbtn" onClick={handleDeleteWorkflow}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Workflow;
